



import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import InstitutionAccountState from "@/models/Accounts/InstitutionAccounts/InstitutionAccountState";

@Component({ name: 'InstitutionAccountState', })
export default class extends SaascadaVue {

    @Prop({ required: true })
    state: InstitutionAccountState;

    get textColor() {
        var color: string = "grey--text";
        switch (this.state) {
            case InstitutionAccountState.Enabled:
                color = "success--text";
                break;
        }
        return color;
    }

}
